module.exports = __webpack_public_path__ + "static/media/strong.85be97dc.jpg";